import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  background-color: ${(props) => props.bannerImage ? 'rgba(255, 255, 255, 0)' : props.bgColor};
  background-image: ${(props) => props.bannerImage ?
    `linear-gradient(0deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.2) 100%), url(${props.bannerImage})` :
    `url(${props.bannerPattern})`
};
  background-position: center;
  background-size: cover;
  min-height: 200px;
  overflow: hidden;
`;

export const HeaderDetailsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const HeaderChipTextContainer = styled.div`
  color: ${(props) => props.theme['color.text.body']};
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.8px;
`;

export const CohortNameContainer = styled.div`
  font-size: 32px;
  line-height: 1.1;
  flex: 1 1 auto;
  color: ${(props) => props.theme['color.text.title']};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 900px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    font-size: 28px;
  }
`;

export const SharingDialogWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1 0 auto;
  padding-top: 6px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    flex-direction: row-reverse;
  }
`;

export const HeaderDetailsRow = styled.div`
  display: grid;
  grid-gap: 40px;
  grid-template-columns: 1fr auto;
  padding: 0 40px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 0 10px;
    grid-template-columns: 100%;
    grid-gap: 10px;
  }
`;

export const InstructorsTextContainer = styled.div`
  display: flex;
  height: 42px;
  align-items: center;
  margin-right: 10px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.8px;
  line-height: 1.1;
  color: ${(props) => props.theme['color.text.body']};

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    margin-right: 0;
    margin-left: 10px;
  }
`;
